import { render, staticRenderFns } from "./LevenshteinFlagField.vue?vue&type=template&id=30a993e4&scoped=true"
import script from "./LevenshteinFlagField.vue?vue&type=script&lang=ts"
export * from "./LevenshteinFlagField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a993e4",
  null
  
)

export default component.exports